import permissions from "app/permissions";
import { graduationRequests } from "api/graduationApi";
import { getPermissions } from "auth/security/securityUtils";
import AcademicYearFilterInput from "server/components/Fields/AcademicYearFilterInput";
import {
  Datagrid,
  DateField,
  EditButton,
  List,
  ListActions,
  ReferenceField,
  ReferenceInput,
  SelectInput,
  ShowButton,
  SimpleList,
  TextField,
} from "react-admin";
import { useMediaQuery } from "@mui/material";
import SecuredComponent from "server/security/SecuredComponent";
import { checkPermission } from "server/security/utils";
import { studentRequests } from "api/studentApi";
import { administrationRequests } from "api/administrationApi";
import { settings } from "app";
import { MobileListRow } from "features/MobileListRow";
import { formatDateOnlyBg } from "server/formatting/formatDateBg";
import { MOBILE_BREAKPOINT } from "utils/constants";

const ListInternshipSessions = () => {
  const isMobile = useMediaQuery(MOBILE_BREAKPOINT);
  const filters = [
    <AcademicYearFilterInput
      source="AcademicYearId"
      label="Учебна година"
      alwaysOn
    />,
    <ReferenceInput
      source="structuralUnitId"
      reference={administrationRequests.getStructuralUnitsSelect()}
      alwaysOn
    >
      <SelectInput
        optionText="name"
        label="Факултет"
        emptyText={false}
      />
    </ReferenceInput>,
    <ReferenceInput
      source="type"
      reference={graduationRequests.getInternshipSessionTypesSelect()}
      alwaysOn
    >
      <SelectInput
        optionText="nameBg"
        label="Тип"
        emptyText={false}
      />
    </ReferenceInput>,
  ];

  return (
    <List
      exporter={false}
      title="Сесии"
      filters={filters}
      actions={<ListActions hasCreate={checkPermission(getPermissions(), permissions.canManageInternshipSessions)} />}
    >
      {isMobile ? (
        <SimpleList
          linkType={false}
          sx={settings.style.mobileList}
          primaryText={() => (
            <div>
              <MobileListRow
                fields={[
                  {
                    label: "Факултет",
                    value: (
                      <ReferenceField
                        source="structuralUnitId"
                        reference={administrationRequests.getStructuralUnitsSelect()}
                      >
                        <TextField source="name" />
                      </ReferenceField>
                    ),
                  },
                ]}
              />
              <MobileListRow
                fields={[
                  {
                    label: "Учебна година",
                    value: (
                      <ReferenceField
                        source="academicYearId"
                        reference={studentRequests.getAcademicYearsSelect()}
                      >
                        <TextField source="name" />
                      </ReferenceField>
                    ),
                  },
                ]}
              />
            </div>
          )}
          secondaryText={record => (
            <div>
              <MobileListRow
                fields={[
                  {
                    label: "Тип",
                    value: (
                      <ReferenceField
                        source="type"
                        reference={graduationRequests.getInternshipSessionTypesSelect()}
                      >
                        <TextField source="nameBg" />
                      </ReferenceField>
                    ),
                  },
                ]}
              />
              <MobileListRow
                fields={[
                  { label: "Дата на започване", value: formatDateOnlyBg(record?.startDate) },
                  { label: "Дата на приключване", value: formatDateOnlyBg(record?.endDate) },
                ]}
              />
            </div>
          )}
          tertiaryText={() => (
            <>
              <SecuredComponent permission={permissions.canManageInternshipSessions}>
                <EditButton label="" />
              </SecuredComponent>
              <SecuredComponent permission={permissions.canPreviewInternshipSessions}>
                <ShowButton label="" />
              </SecuredComponent>
            </>
          )}
        />
      ) : (
        <Datagrid
          bulkActionButtons={false}
          rowClick={false}
        >
          <ReferenceField
            label="Факултет"
            source="structuralUnitId"
            sortable={false}
            reference={administrationRequests.getStructuralUnitsSelect()}
          >
            <TextField
              source="name"
              sortable={false}
            />
          </ReferenceField>
          <ReferenceField
            source="academicYearId"
            reference={studentRequests.getAcademicYearsSelect()}
            label="Учебна година"
            sortable={false}
          >
            <TextField source="name" />
          </ReferenceField>
          <ReferenceField
            label="Тип"
            source="type"
            reference={graduationRequests.getInternshipSessionTypesSelect()}
          >
            <TextField
              source="nameBg"
              sortable={false}
            />
          </ReferenceField>
          <DateField
            source="startDate"
            label="Дата на започване"
            sortable={false}
            locales="bg-BG"
          />
          <DateField
            source="endDate"
            label="Дата на приключване"
            sortable={false}
            locales="bg-BG"
          />
          <SecuredComponent permission={permissions.canManageInternshipSessions}>
            <EditButton />
          </SecuredComponent>
          <SecuredComponent permission={permissions.canPreviewInternshipSessions}>
            <ShowButton />
          </SecuredComponent>
        </Datagrid>
      )}
    </List>
  );
};

export default ListInternshipSessions;
